import styled from 'styled-components'
import { FlexContainer } from './Kit/Container'

export const CallHomeContainer = styled(FlexContainer)`
  height: 100vh;
  justify-content: ${({ isMobile }) => (isMobile ? 'start' : 'center')};
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`
